import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class GoalCollectionsTranslations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'GoalCollectionsTranslations'
  // Define default properties here
  static instanceDefaults () {
    return {
      title: '',
      description: null,
      localeId: 1,
      goalCollectionId: null,
    }
  }
}
const servicePath = 'goal-collections-translations'
const servicePlugin = makeServicePlugin({
  Model: GoalCollectionsTranslations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
